export const STATUS = {
  UNINITIALIZED: 'edrolo/exams/UNINITIALIZED',
  LOADING: 'edrolo/exams/LOADING',
  READY: 'edrolo/exams/READY',
  FAILURE: 'edrolo/exams/FAILURE',
  RELOADING: 'edrolo/exams/RELOADING',
};
